module.exports = {
  messages: {
    CN: {
      input: '请输入',
      select: '请选择',
      name: '任务名',
      describe: '任务描述',
      executor: '执行人',
      duty: '责任人',
      time: '提醒时间',
      type: '任务类型',
    },
    HK: {
      input: '請輸入',
      select: '請選擇',
      name: '任務名',
      describe: '任務描述',
      executor: '執行人',
      duty: '責任人',
      time: '提醒時間',
      type: '任務類型',
    },
    US: {
      input: 'Please enter',
      select: 'Please select',
      name: 'Task Name',
      describe: 'Task Describe',
      executor: 'Executor',
      duty: 'Duty Person',
      time: 'Reminder Time',
      type: 'Task Type',
    }
  }
}
